import NotFoundRoute from "@/router/NotFoundRoute.vue";
import AjaxContent from "./AjaxContent.vue";

export default [
  {
    path: '/:pathMatch(.*)*',
    // component: AjaxContent
    component: NotFoundRoute
  }
];
